/* -------------------------------------------------------------------------- *
 * Country State/Province show hide *
 * -------------------------------------------------------------------------- *
*/

const settings = {
    selector: '#form-input-country',
};

/* ------------- *
 * Module Export *
 * ------------- */

const FormCountry = {
    selector: settings.selector,

    init(selector = settings.selector) {
        const country_el = document.querySelector(selector);
        const fieldUs = document.getElementById('form-input-state');
        const fieldCan = document.getElementById('form-input-province');
        country_el.addEventListener('change', () => {
            fieldCan.selectedIndex = 0;
            fieldUs.selectedIndex = 0;
        });
    },
};

export default FormCountry;
